<template>
  <div class="ui-banner-wrapper">
    <img v-lazy="bannerImg" class="img banner" />
    <div class="btn btn-aside" @click="handleClickAsideBtn" v-if="activityList.length > 0">
      <span>{{ btnAsideText }}</span>
      <i class="icon icon-arrow-right"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "uiBanner",
  props: {
    btnAsideText: {
      type: String,
      default: "切换城市"
    },
    bannerImg: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClickAsideBtn() {
      this.$emit("clickAsideBtn")
    }
  },
  computed: {
    ...mapGetters({
      activityList: "activityInfo/activityList"
    })
  }
}
</script>

<style lang="scss" scoped>
.ui-banner-wrapper {
  width: 100%;
  height: 4.22rem;
  position: relative;
  z-index: 1;
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    vertical-align: top;
  }
  .btn-aside {
    position: absolute;
    top: 0.9rem;
    right: 0;
    font-family: PingFangSC-Regular;
    font-size: 0.26rem;
    color: #ffffff;
    letter-spacing: 0;
    padding-left: 0.2rem;
    padding-right: 0.09rem;
    line-height: 0.56rem;
    display: flex;
    align-items: center;
    border-top-left-radius: 0.28rem;
    border-bottom-left-radius: 0.28rem;
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    &:active {
      opacity: 0.7;
    }
    .icon-arrow-right {
      width: 0.113rem;
      height: 0.2rem;
      position: relative;
      margin-left: 0.08rem;
      &::after,
      &::before {
        content: "";
        display: block;
        background: #ffffff;
        height: 0.02rem;
        width: 0.14rem;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate3d(0, -50%, 0) rotate(0);
        transform-origin: 100% 50%;
      }
      &::before {
        transform: translate3d(0, -50%, 0) rotate(45deg);
      }
      &::after {
        transform: translate3d(0, -50%, 0) rotate(-45deg);
      }
    }
  }
}
.ui-banner-wrapper.pc {
  width: 100%;
  height: 100%;
  // height: 568px;
  .btn-aside {
    top: 110px;
    font-family: PingFangSC-Regular;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0;
    padding-left: 20px;
    padding-right: 10px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    height: 40px;
    .icon-arrow-right {
      height: 18px;
      width: 9.6px;
      margin-left: 10px;
      &::after,
      &::before {
        height: 1px;
        width: 10px;
      }
    }
  }
}
</style>
